/** Video-upload constants, kept separate from the heavy ffmpeg wrapper so the
 * upload form can validate video files without pulling ffmpeg into the
 * main bundle. */

export const VIDEO_EXTENSIONS = ['.mp4', '.mov', '.m4v', '.mkv', '.webm', '.avi']

/** Videos are never uploaded — only their audio track is — so the size cap is
 * about browser memory headroom, not network. */
export const VIDEO_MAX_BYTES = 1024 * 1024 * 1024 // 1 GB

export function isVideoFile(name: string): boolean {
  const ext = '.' + (name.split('.').pop()?.toLowerCase() ?? '')
  return VIDEO_EXTENSIONS.includes(ext)
}
